
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelBanner from "@/views/banner管理/model/DZModelBanner";


class DZServiceBanner {

    list_banner : Array<DZModelBanner> = [];

    m_banner = new DZModelBanner();
    
    net_list_banner(){
        nyNetwork.net("banner列表",{}, data => {
            this.list_banner = data
        })
    }

    net_add_banner(success: () => void){
        nyNetwork.net("添加banner",this.m_banner, data => {
            success()
        })
    }

    net_edit_banner(success: () => void){
        nyNetwork.net("修改banner",this.m_banner, data => {
            success()
        })
    }

    net_del_banner(id,success: () => void){
        nyNetwork.net("删除banner",{id:id}, data => {
            success()
        })
    }

    land_list = []
    net_list_land(){
        nyNetwork.get("土地下拉列表",{}, data => {
            this.land_list = data.data
        })
    }

    homestay_list = []
    net_list_homestay(){
        nyNetwork.get("民宿下拉列表",{}, data => {
            this.homestay_list = data.data
        })
    }

    courtship_list = []
    net_list_courtship(){
        nyNetwork.get("招商下拉列表",{}, data => {
            this.courtship_list = data.data
        })
    }

    demand_list = []
    net_list_demand(){
        nyNetwork.get("需求下拉列表",{}, data => {
            this.demand_list = data.data
        })
    }
}
export default DZServiceBanner;